<template>
  <div>
    <div style="display: flex" v-show="detailDialog">
      <div class="flex">
        <div>
          <el-select
            class="btn"
            clearable
            v-model="isRobot"
            filterable
            placeholder="机器人筛选"
          >
            <el-option
              v-for="item in isRobotOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-input
            placeholder="订单id"
            clearable
            class="btn orderId"
            v-model="SearchOrderId"
          ></el-input>
          <el-input
            placeholder="账户id"
            clearable
            class="btn accountId"
            v-model="defalutAccountId"
          ></el-input>
          <el-select
            class="btn"
            clearable
            v-model="defalutSymbolId"
            filterable
            placeholder="请选择symbolId"
          >
            <el-option
              v-for="item in pairList"
              :key="item.id"
              :label="item.symbol"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
            class="btn"
            clearable
            v-model="stateType"
            filterable
            placeholder="请选择订单状态"
          >
            <el-option
              v-for="item in stateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button type="primary" @click="searchId" style="margin-right: 10px"
            >搜索</el-button
          >
        </div>
        <div v-if="false">
          <el-input
            placeholder="账户id"
            clearable
            class="btn"
            v-model="accountId"
          ></el-input>
          <!-- <el-input placeholder="symbolId" clearable class='btn' v-model="symbolId"></el-input> -->
          <el-select
            v-model="symbolId"
            class="btn"
            clearable
            filterable
            placeholder="请选择交易对"
          >
            <el-option
              v-for="item in pairList"
              :key="item.id"
              :label="item.symbol"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-button type="danger" @click="cancelAllOrder">一键撤销</el-button>
        </div>
      </div>
    </div>
    <div style="display: flex" v-show="!detailDialog">
      <i class="el-icon-back" @click="goback"></i>
      <el-input placeholder="订单id" class="btn"></el-input>
      <el-button type="primary">明细搜索</el-button>
    </div>

    <el-divider></el-divider>
    <el-table
      :data="orderList"
      size="small"
      v-show="detailDialog"
      border
      height="calc(100vh - 360px)"
    >
      <el-table-column label="账户id" prop="accountId" fixed></el-table-column>
      <el-table-column
        label="订单id"
        prop="orderId"
        fixed
        width="150px"
      ></el-table-column>
      <el-table-column label="创建时间" width="140px">
        <template slot-scope="scope">{{
          scope.row.createdTime | moment
        }}</template>
      </el-table-column>
      <el-table-column label="更新时间" width="140px">
        <template slot-scope="scope">{{
          scope.row.updatedTime | moment
        }}</template>
      </el-table-column>
      <el-table-column
        label="成交均价"
        prop="avgPrice"
        align="center"
      ></el-table-column>
      <el-table-column
        label="成交金额"
        prop="dealAmount"
        width="120px"
        align="center"
      ></el-table-column>
      <el-table-column
        label="成交单位"
        prop="dealCoin"
        align="center"
      ></el-table-column>
      <el-table-column
        label="交易对"
        prop="symbol"
        width="120px"
        align="center"
      ></el-table-column>
      <el-table-column
        label="已成交数量"
        prop="executedQty"
        align="center"
        width="140"
      ></el-table-column>
      <el-table-column label="手续费" align="center">
        <template slot-scope="scope">{{
          scope.row.fee == null ? "--" : scope.row.fee
        }}</template>
      </el-table-column>
      <el-table-column
        label="成交均价"
        prop="avgPrice"
        align="center"
      ></el-table-column>
      <el-table-column label="下单方向" prop="orderSide" align="center">
        <template slot-scope="scope">{{
          scope.row.orderSide === 1 ? "买入" : "卖出"
        }}</template>
      </el-table-column>
      <el-table-column label="订单类型" prop="orderType">
        <template slot-scope="scope">{{
          scope.row.orderType === 1 ? "限价" : "市价"
        }}</template>
      </el-table-column>
      <el-table-column label="委托数量" prop="origQty"></el-table-column>
      <el-table-column label="委托价格" prop="price"></el-table-column>
      <el-table-column label="订单状态">
        <template slot-scope="scope">
          <span v-if="scope.row.state === 1">新建订单</span>
          <span v-else-if="scope.row.state === 2">部分成交</span>
          <span v-else-if="scope.row.state === 3">全部成交</span>
          <span v-else-if="scope.row.state === 4">用户撤销</span>
          <span v-else-if="scope.row.state === 5">下单失败</span>
          <span v-else>已过期</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="210px" align="center">
        <template slot-scope="scope">
          <el-button
            :disabled="
              scope.row.state == 1 || scope.row.state == 2 ? false : true
            "
            size="mini"
            type="warning"
            @click="handleCancle(scope.row)"
            >撤销订单</el-button
          >
          <!-- <el-button  
            size="mini"
            type="primary" 
            @click="getDetail(scope.row)" 
          >查看明细</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-table :data="detailList" size="small" v-show="!detailDialog">
      <el-table-column label="账户id" prop="accountId" fixed></el-table-column>
      <el-table-column
        label="订单id"
        prop="orderId"
        fixed
        width="150px"
      ></el-table-column>
      <el-table-column label="创建时间" width="140px">
        <template slot-scope="scope">{{
          scope.row.createdTime | moment
        }}</template>
      </el-table-column>
      <el-table-column label="更新时间" width="140px">
        <template slot-scope="scope">{{
          scope.row.updatedTime | moment
        }}</template>
      </el-table-column>
      <el-table-column
        label="成交均价"
        prop="avgPrice"
        align="center"
      ></el-table-column>
      <el-table-column
        label="dealAmount"
        prop="dealAmount"
        width="120px"
        align="center"
      ></el-table-column>
      <el-table-column
        label="成交单位"
        prop="dealCoin"
        align="center"
      ></el-table-column>
      <el-table-column
        label="交易对"
        prop="symbol"
        width="120px"
        align="center"
      ></el-table-column>
      <el-table-column
        label="已成交数量"
        prop="executedQty"
        align="center"
      ></el-table-column>
      <el-table-column label="手续费" align="center">
        <template slot-scope="scope">{{
          scope.row.fee == null ? "--" : scope.row.fee
        }}</template>
      </el-table-column>
      <el-table-column
        label="成交均价"
        prop="avgPrice"
        align="center"
      ></el-table-column>
      <el-table-column label="下单方向" prop="orderSide" align="center">
        <template slot-scope="scope">{{
          scope.row.orderSide === 1 ? "买入" : "卖出"
        }}</template>
      </el-table-column>
      <el-table-column label="订单类型" prop="orderType">
        <template slot-scope="scope">{{
          scope.row.orderType === 1 ? "限价" : "市价"
        }}</template>
      </el-table-column>
      <el-table-column label="委托数量" prop="origQty"></el-table-column>
      <el-table-column label="委托价格" prop="price"></el-table-column>
      <el-table-column label="订单状态">
        <template slot-scope="scope">
          <span v-if="scope.row.state === 1">新建订单</span>
          <span v-else-if="scope.row.state === 2">部分成交</span>
          <span v-else-if="scope.row.state === 3">全部成交</span>
          <span v-else-if="scope.row.state === 4">用户撤销</span>
          <span v-else-if="scope.row.state === 5">下单失败</span>
          <span v-else>已过期</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="210px">
        <template slot-scope="scope">
          <el-button size="mini" type="warning" @click="handleCancle(scope.row)"
            >撤销订单</el-button
          >
          <!-- <el-button  
            size="mini"
            type="primary" 
            @click="getDetail(scope.row)" 
          >查看明细</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <el-button
        @click="goPrev"
        style="margin-right: 20px"
        type="primary"
        icon="el-icon-arrow-left"
        circle
        :disabled="hasPrev == false"
      ></el-button>
      <el-button
        @click="goNext"
        type="primary"
        icon="el-icon-arrow-right"
        circle
        :disabled="hasNext == false"
      ></el-button>
    </div>

    <!-- <pagination
    v-show="detailDialog"
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination> -->
    <!-- <pagination
    v-show="!detailDialog"
      :size="pagination.size"
      :total="detailTotalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination> -->
    <!-- <update-dialog :val="userinfoDetail" :updateForm="updateForm"></update-dialog> -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import Pagination from "components/pagination";
import updateDialog from "../updatedialog";

export default {
  name: "OrderList",
  data() {
    return {
      // hasPrev:true,
      // hasNext:null,
      isRobot: false,
      defalutSymbolId: 6,
      defalutAccountId: null,
      detailDialog: true,
      SearchOrderId: "",
      list: [],
      accountId: null,
      symbolId: "",
      limit: "15",
      updateForm: {},
      stateType: 1,
      isRobotOptions: [
        { label: "全部", value: "" },
        { label: "机器人订单", value: true },
        { label: "非机器人订单", value: false },
      ],
      stateOptions: [
        { label: "新建订单", value: 1 },
        { label: "部分成交", value: 2 },
        { label: "全部成交", value: 3 },
        { label: "用户撤销", value: 4 },
        { label: "下单失败", value: 5 },
        { label: "已过期", value: 6 },
      ],
      userTypes: {
        1: "无效用户",
        2: "普通用户",
        3: "初级股东",
        4: "中级股东",
        5: "高级股东",
      },
      updateUserTypeDialogVisible: false,
      newUserType: "",
      selectedForUserType: {},
    };
  },
  components: {
    Pagination,
    updateDialog,
  },
  methods: {
    ...mapActions("orderLimit", [
      "getOrderList",
      "getOrderDetails",
      "cancleOrder",
      "cancelAll",
      "getPairList",
    ]),
    ...mapMutations("orderLimit", [
      "setUserinfoDetailDialogVisible",
      "setUserinfoDetail",
    ]),
    searchId() {
      this.getOrderList({
        isRobot: this.isRobot,
        state: this.stateType,
        orderId: this.SearchOrderId,
        symbolId: Number(this.defalutSymbolId),
        limit: this.limit,
        accountId:
          this.defalutAccountId == "" ? null : Number(this.defalutAccountId),
      });
    },
    goPrev() {
      this.getOrderList({
        symbolId: Number(this.defalutSymbolId),
        limit: this.limit,
        accountId:
          this.defalutAccountId == "" ? null : Number(this.defalutAccountId),
        direction: "PREV",
        id: this.orderList[0].orderId,
      });
    },
    goNext() {
      this.getOrderList({
        symbolId: Number(this.defalutSymbolId),
        limit: this.limit,
        accountId:
          this.defalutAccountId == "" ? null : Number(this.defalutAccountId),
        direction: "NEXT",
        id: this.orderList[this.orderList.length - 1].orderId,
      });
    },
    pageChanged(pagination) {
      this.limit = pagination.size;
      this.getOrderList({
        symbolId: Number(this.defalutSymbolId),
        limit: this.limit,
        accountId:
          this.defalutAccountId == "" ? null : Number(this.defalutAccountId),
      });
      this.$emit("refresh", pagination);
    },
    goback() {
      this.detailDialog = true;
    },
    //撤销所有订单
    cancelAllOrder() {
      this.$confirm("此操作将撤销所选用户所有订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.cancelAll({
            accountId: Number(this.accountId),
            symbolId: this.symbolId,
          }).then((res) => {
            if (res.code == 0) {
              this.searchId();
              this.$message({
                type: "success",
                message: "撤销成功!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消撤销",
          });
        });
    },
    //撤销订单
    handleCancle(row) {
      this.cancleOrder(row.orderId).then((res) => {
        if (res.code == 0) {
          this.searchId();
        }
      });
    },
    //查看成交明细
    getDetail(row) {
      (this.detailDialog = false),
        this.getOrderDetails({
          current: 1,
          orderId: row.orderId,
          size: 25,
        }).then((res) => {});
    },
  },
  computed: {
    ...mapGetters("orderLimit", ["userList"]),
    ...mapState("orderLimit", [
      "pairList",
      "hasPrev",
      "hasNext",
      "pagination",
      "totalCount",
      "userinfoDetail",
      "userinfoDetailDialogVisible",
      "orderList",
      "detailList",
      "detailTotalCount",
    ]),
  },

  mounted() {
    this.searchId();
    this.getPairList();
  },
};
</script>

<style lang="less" scoped>
.user-type-select {
  width: 100%;
}
.page {
  // margin-top: 30px;
  width: 100px;
  margin: 30px auto;
  display: flex;
}

.red {
  color: skyblue;
  font-weight: bold;
}
.el-icon-back:before {
  content: "\E6EA";
  font-size: 30px;
  cursor: pointer;
  line-height: 40px;
}
.el-icon-back {
  width: 40px;
  height: 40px;
}
.flex {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.btn {
  width: 160px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.accountId {
  width: 180px;
}
.orderId {
  width: 200px;
}
</style>
